import React from "react";
import { Box, Checkbox, FormControlLabel, styled } from "@mui/material";
import { FilterItem, FilterValue } from "../types";

const ChipsContainer = styled(Box)`
  display: block;
  margin: ${({ theme }) => theme.spacing(2.5, 0, 2.5, 3)};
  label {
    align-items: center;
  }
`;

interface Props {
  options: FilterItem[];
  selectedOptions: FilterValue[];
  setSelectedOptions: (options: FilterValue[]) => void;
  hasAllOption?: boolean;
  singleSelectMode?: boolean;
}

export const Checkboxes = ({
  options,
  selectedOptions,
  setSelectedOptions,
  hasAllOption = true,
  singleSelectMode = false,
}: Props) => {
  const onChipSelect = (value: FilterValue) => {
    if (singleSelectMode) {
      if (!selectedOptions.includes(value)) setSelectedOptions([value]);
      return;
    }

    if (value === "all") {
      return setSelectedOptions(["all"]);
    }

    if (selectedOptions.includes(value)) {
      const temp = selectedOptions.filter((chip) => chip !== value);
      return setSelectedOptions(
        temp.length === 0 ? (hasAllOption ? ["all"] : []) : temp
      );
    }
    setSelectedOptions([...selectedOptions.filter((x) => x !== "all"), value]);
  };

  return (
    <ChipsContainer>
      {options.map((item) => (
        <FormControlLabel
          label={item.text}
          control={
            <Checkbox
              checked={selectedOptions.includes(item.value) || false}
              value={item.text}
              onChange={(_, value) => {
                onChipSelect(item.value);
              }}
            />
          }
          sx={{ alignItems: "flex-start", height: "42px" }}
        />
      ))}
    </ChipsContainer>
  );
};
